import { useRef } from "react";
import type { MutableRefObject } from "react";

/**
 * Returns a ref whose `current` is always the latest value passed in.
 *
 * Read `ref.current` inside long-lived callbacks (tool registrations, subscriptions) to get
 * fresh props and state. List the ref, not the values, as the effect dependency: its identity
 * never changes, so the effect does not re-run when the values do.
 *
 * `current` is assigned during render so a callback that fires before the next effect still
 * sees the latest value.
 */
export const useRefOf = <T>(value: T): Readonly<MutableRefObject<T>> => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};
